Object.defineProperty(exports, '__esModule', { value: true });

const misc = require('./misc.js');

/**
 * Returns a new minimal propagation context
 */
function generatePropagationContext() {
  return {
    traceId: misc.uuid4(),
    spanId: misc.uuid4().substring(16),
  };
}

exports.generatePropagationContext = generatePropagationContext;
//# sourceMappingURL=propagationContext.js.map
